module.exports = __webpack_public_path__ + "img/staff-default-women.332b1ebd.png";